import { Component } from 'react';
import { __extends } from '../../_virtual/_tslib.js';
import withChat from '../Provider/withChat.js';
import isEqual from 'lodash/isEqual';

var UserQuery =
/** @class */
function (_super) {
  __extends(UserQuery, _super);

  function UserQuery(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      loading: _this.props.userIds.length > 0
    };
    _this.load = _this.load.bind(_this);
    _this.cancel = _this.cancel.bind(_this);
    return _this;
  }

  UserQuery.prototype.componentDidMount = function () {
    if (this.props.chatClient) {
      this.load(this.props.userIds, this.props.chatClient);
    }
  };

  UserQuery.prototype.componentDidUpdate = function (prevProps) {
    // Firebase client no longer available
    if (!this.props.chatClient) {
      this.cancel();
    } // Conversation or authenticated user has changed


    if (prevProps.chatClient !== this.props.chatClient || !isEqual(prevProps.userIds.sort(), this.props.userIds.sort()) || prevProps.authenticatedUserId !== this.props.authenticatedUserId) {
      this.cancel();

      if (this.props.chatClient) {
        this.load(this.props.userIds, this.props.chatClient);
      }
    }
  };

  UserQuery.prototype.componentWillUnmount = function () {
    this.cancel();
  };

  UserQuery.prototype.load = function (userIds, client) {
    var _this = this;

    var allUsersAlreadyLoaded = userIds.every(function (userId) {
      return _this.state.users && _this.state.users.find(function (user) {
        return user.userId === userId;
      });
    });

    if (allUsersAlreadyLoaded) {
      return;
    }

    this.setState({
      users: undefined,
      loading: true
    });
    client.getUsers(userIds).then(function (users) {
      _this.setState({
        loading: false,
        users: users
      });
    });
  };
  /**
   * TODO: Implement cancellation
   *
   * Without it, the getUsers callback might call setState on an unmounted component
   */


  UserQuery.prototype.cancel = function () {};

  UserQuery.prototype.render = function () {
    /**
     * `this.state.loading` only tracks whether the `getUsers` call is unfinished.
     *   We also need to consider the loading/auth state of the chat client itself.
     */
    var loading = this.state.loading || !this.props.chatClient;
    return this.props.children({
      loading: loading,
      users: this.state.users
    });
  };

  return UserQuery;
}(Component);

var UserQuery$1 = withChat(UserQuery);

export default UserQuery$1;
//# sourceMappingURL=index.js.map
